<!-- 大屏收益 -->
<template>
  <div v-loading="loading" class="screen">
    <div v-if="tvdata">
      <meters :tvdata="tvdata" />
    </div>
    <div v-if="error" class="error column-flex align-center center">
      <p>没有大屏数据，请关闭该页面</p>
      <section class="error-container">
        <span class="four"><span class="screen-reader-text">4</span></span>
        <span class="zero"><span class="screen-reader-text">0</span></span>
        <span class="four"><span class="screen-reader-text">4</span></span>
      </section>
    </div>
  </div>
</template>

<script>
import meters from './meter.vue'
import { GetUniversalTVOverviewData } from '@apis/TV.js'

/** 电表通用大屏 */
export default {
  name: 'CommonLargeScreen',
  components: {
    meters
  },
  data () {
    return {
      bigscreen: '',
      loading: false,
      error: false,
      tvdata: '',
      stationId: '',
      screenTimer: null
    }
  },
  created () {
    this.stationId = this.$route.params.id
  },
  mounted () {
    this.getUniversalTVdata()
    this.screenTimer = setInterval(() => {
      this.getUniversalTVdata()
    }, 5 * 60 * 1000)
  },
  beforeDestroy () {
    if (this.screenTimer) {
      clearInterval(this.screenTimer)
    }
  },
  methods: {
    /** 获取通用接口大屏数据 */
    getUniversalTVdata () {
      if (this.stationId) {
        this.loading = true
        GetUniversalTVOverviewData({
          id: this.$store.getters.station.id || this.$route.params.id || '',
        }).then(({ data }) => {
          if (data) {
            this.tvdata = data
            this.bigscreen = '1'
          } else {
            this.tvdata = []
            this.bigscreen = ''
          }
        }).catch(() => {
          this.error = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.tvdata = []
        this.bigscreen = ''
      }
    }
  }
}
</script>
<style scoped>
.screen {
  width: 100vw;
  height: 100vh;
}

.error {
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-color: #fdfaf5;
  color: #bbb
}

p {
  font-size: 40px;
  line-height: 40px;
}

.close {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 30px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.07) 40%, transparent 41%, transparent 100%), linear-gradient(96deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.07) 50%, transparent 51%, transparent 100%), linear-gradient(to top, #99749d, #b895ab, #cc9aa6, #d7969e, #e0787f);
  ;
  border-radius: 8px;
}

.error-container {
  text-align: center;
  font-size: 106px;
  font-family: "Catamaran", sans-serif;
  font-weight: 800;
  margin: 70px 15px;
}

.error-container>span {
  display: inline-block;
  position: relative;
}

.error-container>span.four:before,
.error-container>span.four:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 999px;
}

.error-container>span.four:before {
  width: 43px;
  height: 156px;
  left: 60px;
  bottom: -43px;
  background: linear-gradient(128deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.07) 40%, transparent 41%, transparent 100%), linear-gradient(116deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.07) 50%, transparent 51%, transparent 100%), linear-gradient(to top, #99749d, #b895ab, #cc9aa6, #d7969e, #e0787f);
}

.error-container>span.four:after {
  width: 137px;
  height: 43px;
  transform: rotate(-49.5deg);
  left: -18px;
  bottom: 36px;
  background: linear-gradient(to right, #99749d, #b895ab, #cc9aa6, #d7969e, #e0787f);
}

.error-container>span.four {
  width: 136px;
  height: 43px;
  border-radius: 999px;
  background: linear-gradient(140deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.07) 43%, transparent 44%, transparent 100%), linear-gradient(105deg, transparent 0%, transparent 40%, rgba(0, 0, 0, 0.06) 41%, rgba(0, 0, 0, 0.07) 76%, transparent 77%, transparent 100%), linear-gradient(to right, #d89ca4, #e27b7e);
}

.screen-reader-text {
  position: absolute;
  top: -9999em;
  left: -9999em;
}

.error-container>span.zero {
  vertical-align: text-top;
  width: 156px;
  height: 156px;
  border-radius: 999px;
  background: linear-gradient(-45deg, transparent 0%, rgba(0, 0, 0, 0.06) 50%, transparent 51%, transparent 100%), linear-gradient(to top right, #99749d, #99749d, #b895ab, #cc9aa6, #d7969e, #ed8687, #ed8687);
  overflow: hidden;
  animation: bgshadow 5s infinite;
}

.error-container>span.zero:before {
  content: "";
  display: block;
  position: absolute;
  transform: rotate(45deg);
  width: 90px;
  height: 90px;
  background-color: transparent;
  left: 0px;
  bottom: 0px;
  background: linear-gradient(95deg, transparent 0%, transparent 8%, rgba(0, 0, 0, 0.07) 9%, transparent 50%, transparent 100%), linear-gradient(85deg, transparent 0%, transparent 19%, rgba(0, 0, 0, 0.05) 20%, rgba(0, 0, 0, 0.07) 91%, transparent 92%, transparent 100%);
}

.error-container>span.zero:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 999px;
  width: 70px;
  height: 70px;
  left: 43px;
  bottom: 43px;
  background: #fdfaf5;
  box-shadow: -2px 2px 2px 0px rgb(0 0 0 / 10%);
}

@keyframes bgshadow {
  0% {
    box-shadow: inset -160px 160px 0px 5px rgb(0 0 0 / 40%);
  }

  45% {
    box-shadow: inset 0px 0px 0px 0px rgb(0 0 0 / 10%);
  }

  55% {
    box-shadow: inset 0px 0px 0px 0px rgb(0 0 0 / 10%);
  }

  100% {
    box-shadow: inset 160px -160px 0px 5px rgb(0 0 0 / 40%);
  }
}
</style>
